export default __webpack_public_path__ + "static/media/person4.ed00c31f.png";